
@if(showForm()){
    <survey-header 
        [isModal]="isModal" 
        [languages]="languages" 
        [surveyName]="surveyName" 
        [logo]="surveyLogo" 
        [headerColor]="surveyStyle?.header_color"
    />

    <div 
      class="survey-content" 
      [ngStyle]="{'background': surveyStyle?.bg_color || '#fff'}"
    >
        <form [formGroup]="surveyForm" [ngStyle]="{'background': surveyStyle?.survey_color || '#FFF'}">
            @for(data of formData; track $index) {
                <div class="question-entry">
                    <label 
                      class="question-entry__title" 
                      [ngStyle]="{'color': surveyStyle?.text_color}"
                    >
                      {{data.title}} 
                      @if(data.required) {
                        <sup class="required">*</sup>
                      }
                    </label>
    
                    @if(data.type === 'satisfaction_level_3' || data.type === 'satisfaction_level_5'){
                        <div class="question-entry__faces-container">
                            @for(face of data.options; track $index) {
                                <label>
                                    <input type="radio" [value]="face" [formControlName]="data.key" [name]="data.key" (change)="setSelectedOption(face, data.key)">
                                    <img src="/assets/imgs/face-{{ data.options.length }}-{{ face }}.png" draggable="false" [ngClass]="surveyForm.value?.[data?.key] === face ? 'selected animate__animated animate__rubberBand' : 'no_selected'" >
                                </label>
                            }
                        </div>
                    }
    
                    @if(data.type === 'text'){
                        <input type="text" [formControlName]="data.key" [name]="data.key">
                    }
    
                    @if(data.type === 'selection_unique'){
                        @if(!shouldUseColumns(data.options)) {
                            <!-- Layout normal para 4 opciones o menos -->
                            <div class="question-entry__selection-survey">
                                @for(option of data.options; track $index) {
                                    <div class="question-entry__selection-survey__question">
                                        <label>
                                          <input 
                                            type="radio" 
                                            [value]="option" 
                                            [formControlName]="data.key" 
                                            [name]="data.key" 
                                            (change)="setSelectedOption(option, data.key)" 
                                            [required]="data.required"
                                          />
                                          {{ option| translate }} 
                                        </label>
                                    </div>
                                }
                                
                                @if(!data.required) {
                                  <div class="question-entry__selection-survey__question">
                                    <label>
                                      <input 
                                        type="radio" 
                                        [value]="null" 
                                        [formControlName]="data.key" 
                                        [name]="data.key" 
                                        (change)="setSelectedOption(null, data.key)" 
                                        [required]="data.required"
                                      />
                                      {{ 'Ninguno' | translate }}
                                    </label>
                                  </div>
                                }
                            </div>
                        } @else {
                            <!-- Layout de dos columnas para más de 4 opciones -->
                            <div class="question-entry__selection-survey question-entry__selection-survey--two-columns">
                                <div class="question-entry__selection-survey__column">
                                    @for(option of getFirstColumnOptions(data.options); track $index) {
                                        <div class="question-entry__selection-survey__question">
                                            <label>
                                              <input 
                                                type="radio" 
                                                [value]="option" 
                                                [formControlName]="data.key" 
                                                [name]="data.key" 
                                                (change)="setSelectedOption(option, data.key)" 
                                                [required]="data.required"
                                              />
                                              {{ option| translate }}
                                            </label>
                                        </div>
                                    }
                                  
                                </div>
                                <div class="question-entry__selection-survey__column">
                                    @for(option of getSecondColumnOptions(data.options); track $index) {
                                        <div class="question-entry__selection-survey__question">
                                            <label>
                                              <input 
                                                type="radio" 
                                                [value]="option" 
                                                [formControlName]="data.key" 
                                                [name]="data.key" 
                                                (change)="setSelectedOption(option, data.key)" 
                                                [required]="data.required"
                                              />
                                              {{ option| translate }}
                                            </label>
                                        </div>
                                    }

                                    @if(!data.required) {
                                      <div class="question-entry__selection-survey__question">
                                        <label>
                                          <input 
                                            type="radio" 
                                            [value]="null" 
                                            [formControlName]="data.key" 
                                            [name]="data.key" 
                                            (change)="setSelectedOption(null, data.key)" 
                                          />
                                          {{ 'Ninguno' | translate }}
                                        </label>
                                      </div>
                                    }
                                </div>
                            </div>
                        }
                    }
    
                    @if(data.type === 'selection_multi'){
                      @if(!shouldUseColumns(data.options)) {
                        <!-- Layout normal para 4 opciones o menos -->
                        <div [formArrayName]="data.key" class="question-entry__selection-survey">
                            @for(option of getMultiControls(data.key); track $index) {
                                <div class="question-entry__selection-survey__question">
                                    <label>
                                      <input 
                                        type="checkbox" 
                                        [formControl]="$any(option.get('selected'))" 
                                      />
                                      {{ option.get('value').value | translate }}
                                    </label>
                                </div>
                            }
                        </div>
                      } @else {
                        <!-- Layout de dos columnas para más de 4 opciones -->
                        <div [formArrayName]="data.key" class="question-entry__selection-survey question-entry__selection-survey--two-columns">
                            <div class="question-entry__selection-survey__column">
                                @for(option of getFirstColumnOptions(getMultiControls(data.key)); track $index) {
                                    <div class="question-entry__selection-survey__question">
                                        <label>
                                          <input 
                                            type="checkbox" 
                                            [formControl]="$any(option.get('selected'))" 
                                          />
                                          {{ option.get('value').value | translate }}
                                        </label>
                                    </div>
                                }
                            </div>
                            <div class="question-entry__selection-survey__column">
                                @for(option of getSecondColumnOptions(getMultiControls(data.key)); track $index) {
                                    <div class="question-entry__selection-survey__question">
                                      <label>
                                        <input 
                                          type="checkbox" 
                                          [value]="null"
                                          [formControl]="$any(option.get('selected'))"
                                          />
                                        {{ option.get('value').value | translate }}
                                      </label>
                                    </div>
                                }
                            </div>
                        </div>
                      }
                    }
                    
                    @if(data.type === 'email'){
                      <div class="question-entry__selection-survey__question question-entry__selection-survey__question--email">
                        <input 
                          type="email" 
                          [formControlName]="data.key" 
                          [name]="data.key" 
                          (change)="setSelectedOption('email', data.key)" 
                          [required]="data.required"
                          placeholder="ejemplo@correo.com"
                        />
                        
                        <!-- Mensajes de error para email -->
                         <div class="email-error-container">
                            @if(surveyForm.get(data.key)?.invalid && surveyForm.get(data.key)?.touched) {
                              <div class="email-error-messages">
                                @if(surveyForm.get(data.key)?.errors?.['required']) {
                                  <small class="error-message">
                                    {{ 'Este campo es requerido' | translate }}
                                  </small>
                                }
                                @if(surveyForm.get(data.key)?.errors?.['email']) {
                                  <small class="error-message">
                                    {{ 'Por favor ingrese un email válido' | translate }}
                                  </small>
                                }
                              </div>
                            }
                         </div>
                      </div>
                    }
                  <hr>
                </div>
            }

            <div class="send-button">
                <button 
                  type="submit"
                  (click)="sendSurvey()" 
                  [disabled]="!isFormValid"
                  [class.disabled]="!isFormValid"
                >
                  {{'Enviar' | translate}}
                </button>
            </div>

        </form>
    </div>
}
